import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Visa = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Visa | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Visa"
        content="For Participants"
        contentTwo="Visa"
        // linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div className="visa">
{/* 
          <h3>Visa Exemptions</h3>
          Vietnam offers visa exemptions to citizens of certain countries for short stays. These exemptions vary in length from 15 to 30 days depending on the visitor`&apos;s nationality. For instance, citizens from some ASEAN countries can enter Vietnam without a visa for a specified period.
          <p>
            <img
              src="./images/visa/visa_exemption.png"
              alt="visa_exemption"
              width="100%"
            />
          </p>
          <h3>Electronic Visa (e-Visa)</h3>
          Vietnam has implemented an e-Visa system for citizens of over 80 countries. The e-Visa is valid for a single entry with a duration of up to 30 days. Applicants can complete the entire application process online, including payment of the visa fee, and receive their e-Visa electronically.
          <br></br>
          More information about e-Visa is available on <a href="https://evisa.immigration.gov.vn/">https://evisa.immigration.gov.vn/</a>
          <h3>Visa on Arrival (VoA)</h3>
          Vietnam offers the Visa on Arrival option for travelers entering the country through certain international airports. However, it`&apos;s crucial to obtain a pre-approval letter before departure. This letter can be applied for online through various agencies. Upon arrival, visitors present the approval letter to receive their visa.

          <h3>Long-Term and Multiple-Entry Visas</h3>
          For visitors planning to stay longer than 30 days or needing multiple entries, Vietnam issues traditional visas that can be applied for at Vietnamese embassies or consulates abroad. These include tourist visas, business visas, student visas, and work visas, among others.

          <h3>Special Considerations</h3>
          Visitors must ensure their passport has at least six months of validity from the date of entry.
          <br></br>
          Vietnam&apos;s visa policies continue to adapt in response to the COVID-19 pandemic, with health declarations and possibly proof of vaccination required for entry.
          <br></br>
          Always check for the latest visa information and entry requirements before traveling.
          <hr></hr>
          <h2>For Chinese, it is recommended to choose e-visa or visa on arrival.</h2> */}
            <h3>
              A Brief Introduction to Republic of Korea Visa and the Procedure for Visa
              Application
            </h3>
            <div align="justify">
            Republic of Korea visa is a permit issued to a foreigner by the Republic of Korea visa authorities for entry into, exit from or transit through the territory of the Republic of Korea. Hereunder is an introduction to the ordinary visa and its application procedure:
            </div>
            <hr></hr>
            <p align="justify">
              <b>e-Visa Application via the Visa Portal</b>
            </p>
            <p align="justify">
              <b>1. Applicant</b>
              <br />
              Application must be submitted by a foreigner or the sponsor on behalf of the foreigner.
            </p>
            <p align="justify">
              <b>2. Applicable Status of Stay (as of Dec. 8, 2014)</b>
            </p>
            <ul>
              <li>
                Professor (E-1), Researcher (E-3), Technical Instructor/Technician (E-4), and Professional (E-5) Visa for the applicant and Dependent Family (F-3) Visa for his/her accompanying family members.
              </li>
              <li>
                Foreign National of Special Ability (E-7) visa for the applicant and Dependent Family (F-3) Visa for his/her accompanying family members.
                <br />
                - Qualification: the applicant must be an expert in advanced science and technology and have an official employment recommendation letter (a.k.a. GOLD CARD)
              </li>
              <li>
                Short-term General (C-3-1) Visa for a prospective investor invited by a promotion agency of the Immigrant Investor Scheme for Public Business and his/her accompanying family members
              </li>
              <li>
                Short-term Group Tourist (C-3-2) Visa for Chinese group tourists who can apply for their Visa through a designated travel agency
              </li>
              <li>
                Short-term Medical Tourist (C-3-3) or Recuperation &amp; Treatment (G-1-10) Visa for foreign patients and their caregivers who are invited by an &apos;outstanding medical facilitator&apos; designated as e-Visa agency.
              </li>
              <li>
                Business Visitor (General) (C-3-4) visa for an invitee of a domestic company
                <br />
                - Qualifications: A foreigner who has entered Korea 3 times or more with a Short-term (C-3) Visa since the implementation of the fingerprint confirmation system for foreigners on Jan. 1, 2012, and who has no history of illegal stay or criminal cases
              </li>
            </ul>
            <p align="justify">
              <b>3. Required Documents</b>
            </p>
            <ul>
              <li>Visa Application Form (electronic form on the Visa Portal)</li>
              <li>Scanned image files of passport pages</li>
              <li>Digital Photograph (in natural color, size: 3.5cm x 4.5cm)</li>
              <li>Fee (credit card for e-Payment)</li>
              <li>
                Required documents for respective status of stay (soft copy)
                <br />
                - Please refer to the guide on required documents for each type of visa on the Visa Navigator or to the Visa Information on the website of a respective diplomatic office.
              </li>
            </ul>

            <hr></hr>

            <p align="justify">
              <b>Confirmation of Visa Issuance Application via the Visa Portal</b>
            </p>
            <p align="justify">
              <b>1. Applicant</b>
              <br />
              Application must be filed by the inviter (sponsor).
            </p>
            <p align="justify">
              <b>2. Applicable Status of Stay (as of Dec. 8, 2014)</b>
            </p>
            <ul>
              <li>
                Professor (E-1), Foreign Language Instructor (E-2), Researcher (E-3), Technical Instructor/Technician (E-4), Professional (E-5) for the applicant and Dependent Family (F-3) Visa for his/her accompanying family members.
              </li>
              <li>
                Foreign National of Special Ability (E-7) Visa for the applicant and Dependent Family (F-3) Visa for his/her accompanying family members.
                <br />
                - Qualification: the applicant must have an occupation under category 1 (executives) or 2 (professionals or related) of the Standard Classification of Occupation announced by the National Statistical Office
              </li>
              <li>
                Short-term Medical Tourist (C-3-3) or Recuperation &amp; Treatment (G-1-10) Visa for foreign patients and their caregivers who are invited by an &apos;outstanding medical facilitator&apos;
              </li>
              <li>Business Visitor (C-3-6) visa for an invitee of a VIP corporation</li>
              <li>Student (D-2) and Korean Language Trainee (D-4-1) visa</li>
              <li>Non-professional (E-9) and Maritime Crew (E-10) visa</li>
            </ul>
            <p align="justify">
              <b>3. Required Documents</b>
            </p>
            <ul>
              <li>Application form for Confirmation of Visa Issuance (electronic form on the Visa Portal)</li>
              <li>Scanned image files of passport pages</li>
              <li>Digital Photograph (in natural color, size: 3.5cm x 4.5cm)</li>
              <li>Fee (credit card for e-Payment)</li>
              <li>
                Required documents for respective status of stay (soft copy)
                <br />
                - Please refer to the guide on required documents for each type of Visa on the Visa Navigator, or to the Visa information on the board of the respective website of the Diplomatic Office.
              </li>
            </ul>
            <p align="justify">
              <b>4. Check the Result of Your Confirmation of Visa Issuance Application</b>
              <br />
              You can check the result of your application – through &quot;Application Status&quot; via the Visa Portal, ARS (02-2650-6363), text message or e-mail address you gave us.
            </p>
            <p align="justify">
              <b>5. Visa Application</b>
            </p>
            <ul>
              <li>
                The sponsor (inviter) must download Visa application form (for the applicant) from &quot;Application Status&quot; on the Visa Portal, and send it to the applicant via email, or inform him/her of the number and expiry date of the confirmation of visa issuance.
              </li>
              <li>
                The applicant must receive Visa application form for the confirmation of visa issuance or its number (expiry date) from the sponsor in Korea in order to apply for his/her visa at the Korean Embassy or Consulate General.
              </li>
            </ul>
            <hr></hr>
            For further information, please consult the nearest Republic of Korea visa authorities.
            The above message is quoted from {" "}
              <a href="https://www.visa.go.kr/">
              Korea Visa Portal
              </a>.

          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
}
else {
  return (
    <React.Fragment>
      <SEO title="Visa | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Visa"
        content="For Participants"
        contentTwo="Visa"
        // linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div>
          <h3>To be released.</h3>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  )
}
};

export default Visa;
